import React from 'react'

const Pagination = ({
  firstItem,
  lastItem,
  totalItems,
  isFirstPage,
  isLastPage,
  handlePreviousPage,
  handleNextPage,
}) => {
  return (
    <nav
      className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
      aria-label="Pagination"
    >
      <div className="hidden sm:block">
        <p className="text-sm text-gray-700">
          Showing <span className="font-medium">{firstItem}</span> to{' '}
          <span className="font-medium">{lastItem}</span> of{' '}
          <span className="font-medium">{totalItems}</span> results
        </p>
      </div>
      <div className="flex-1 flex justify-between sm:justify-end">
        {!isFirstPage && (
          <a
            onClick={handlePreviousPage}
            className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 cursor-pointer"
          >
            Previous
          </a>
        )}
        {!isLastPage && (
          <a
            onClick={handleNextPage}
            className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 cursor-pointer"
          >
            Next
          </a>
        )}
      </div>
    </nav>
  )
}

export default Pagination
